import Vue from 'vue';
import Vuetify from 'vuetify';
import VueRouter from 'vue-router';
import Donut from 'vue-css-donut-chart';
import JsonExcel from 'vue-json-excel';
import router from './router';
import BaseTemp from './views/baseView.vue';

import 'vuetify/dist/vuetify.css';
import 'vue-css-donut-chart/dist/vcdonut.css';

import getSitepass from './sitepass';

const axios = require('axios');


Vue.use(VueRouter);
Vue.use(Donut);
Vue.use(Vuetify, {
  theme: {
    primary: '#AB5932',
    secondary: '#ffffff',
    accent: '#ff6e40',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
  },
});
Vue.component('downloadExcel', JsonExcel);

// router before each should be only used for specific conditions, like login
function checkAuth() {
  return new Promise((resolve, reject) => {
    const sitePass = getSitepass();
    // console.log("sitepass is: ", sitePass)
    return axios
      .get(`${process.env.VUE_APP_backend_url}/validation?sitepass=${sitePass}`)
      .then((response) => {
        // console.log("GET Validation SUCCESS ", response)
        resolve(response.data);
      })
      .catch((error) => {
        // console.log("GET Validation ERROR ", error)
        resolve(false);
      });
  });
}

router.beforeEach((to, from, next) => {
  checkAuth()
    .then((authenticated) => {
      if (authenticated === false) {
        window.location.href = 'https://auth.thinxtra.com/auth/google?externalModule=ems';
      } else {
        next();
      }
    })
    .catch((error) => {
      console.log(error);
    });
});

new Vue({
  router,
  render: h => h(BaseTemp),
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js